import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button, TextField } from '@material-ui/core';
import moment from 'moment';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useStyles } from '../adminStyles';
import ExcelExport from './components/ExportExcel';
import { convertToDateString } from '../../../redux/utils/customMethods';
import { DB_DATE_FORMAT } from '../../../redux/constants';
import { fetchAllUsers } from '../../../redux/users/usersActions';
import { getProjectList } from '../../../redux/projects/projectsActions';
import {
  approveTimesheet,
  fetchTimesheet,
} from '../../../redux/timesheets/timesheetsActions';

import EmployeeDetailDialogue from './components/EmployeeDetailDialogue';
import EmployeeAudit from './components/EmployeeAudit';
import AttachmentDialogue from './components/AttachmentDialogue';
import CommentDialogue from './components/CommentDialogue';
import MainTable from './components/MainTable';
import EditDialogue from './components/EditDialogue';

const columns = [
  { id: 'name', label: 'Name', align: 'center' },
  { id: 'date', label: 'Date', align: 'center' },
  { id: 'totalHrs', label: 'Total Hours', align: 'right' },
  { id: 'attachments', label: 'Attachments', align: 'center' },
  { id: 'comments', label: 'User Comments', align: 'center' },
  { id: 'details', label: 'Task details', align: 'center' },
  { id: 'edit', label: 'Edit', align: 'center' },
  { id: 'approval', label: 'Status', align: 'center' },
  { id: 'Action', label: 'Action', align: 'center' },
];

const employeeDetailColumns = [
  { id: 'date', label: 'Date', align: 'center' },
  { id: 'hours', label: 'Hours', align: 'center' },
  { id: 'projectId', label: 'Project', align: 'center' },
  { id: 'task', label: 'Task', align: 'center' },
  { id: 'status', label: 'Status', align: 'center' },
  { id: 'note', label: 'Note', align: 'center' },
];

const empAuditColumns = [
  { id: 'sno', label: 'S.NO', align: 'center' },
  { id: 'timesheet_status', label: 'Status', align: 'center' },
  { id: 'timesheet_updated_by', label: 'Updated By', align: 'center' },
  { id: 'timesheet_updated_on', label: 'Date', align: 'center' }
];

const commentColumns = [{ id: 'comment', label: 'Comment', align: 'center' }];
//const users = useSelector(state => state.appUsers.usersList || []);

const generate = e =>
  [0, 1].map(value =>
    React.cloneElement(e, {
      key: value,
    })
  );

const TimesheetApproval = () => {
  document.title = 'Sciata Approvals';
  const { arrowIcons, gridElLeft, gridElRight, inputMobile } = useStyles();

  const dispatch = useDispatch();
  const user = useSelector(state => state.users.currentUser);
  const projects = useSelector(state => state.projects);
  const users = useSelector(state => state.users.all);
  const attachments = useSelector(state => state.timesheets.attachments);
  const timesheet = useSelector(state => state.timesheets.currentTimesheet);

  const [detailOpen, setDetailOpen] = useState(false);
  const [auditOpen, setAuditOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [commentOpen, setCommentOpen] = useState(false);
  const [attachmentOpen, setAttachmentOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [orderAscending, setOrderAscending] = useState(true);
  const [asc, setAsc] = useState('desc');
  const [currentYear, setCurrentYear] = useState(moment().get('year'));
  const [searchTerm, setSearchTerm] = useState('');
  const [rows, setRows] = useState([]);
  const [userObj, setUserObj] = useState({});
  const [payPeriod, setPayPeriod] = useState({
    startDate: moment(moment().subtract(1, 'weeks').startOf('week')).format(
      DB_DATE_FORMAT
    ),
    endDate: moment(moment().subtract(1, 'weeks').endOf('week')).format(DB_DATE_FORMAT),
  });

  useEffect(() => {
    if ( payPeriod.startDate && currentYear) {
      dispatch(
        fetchAllUsers({
          fromDate: `${payPeriod.startDate}`,
          toDate: `${payPeriod.endDate}`,
          role: user.role,
          projectCode: '4000',
        })
      );
      dispatch(getProjectList());
    }
  }, [user, payPeriod, currentYear]);

  const rowData = {
    payPeriod: `${payPeriod.startDate} - ${payPeriod.endDate}`,
    timesheets: [],
  };

  const getEditDialogTimesheet = async obj => {
    let _user = {};
    let splitName = obj.name.split(' ');
    let firstName = splitName[0].trim();
    let lastName = splitName[splitName.length - 1].trim();

    _user = await users.users.find(user => {
      return user.firstName.trim() === firstName && user.lastName.trim() === lastName;
    });

    if (_user) {
      let fromDate = _user.weekly[0].fromDate;
      let toDate = _user.weekly[0].toDate;
      let role = _user.role;
      let userId = _user.id;
      dispatch(fetchTimesheet({ fromDate, toDate, role, userId }));
    }
  };

  useEffect(() => {
    users.users &&
      users.users.forEach(user => {
        user.weekly.forEach(timesheet => {
          let nonBillableObj = {
            holiday: 0,
            vacation: 0,
            sick: 0,
          };

          timesheet.days.forEach(item => {
            if (!item.projectId) {
              if (item.task == 'holiday') {
                nonBillableObj.holiday = nonBillableObj.holiday + item.hour;
              } else if (item.task == 'vacation') {
                nonBillableObj.vacation = nonBillableObj.vacation + item.hour;
              } else if (item.task == 'sick')
                nonBillableObj.sick = nonBillableObj.sick + item.hour;
            }
          });

          rowData.timesheets.push({
            tsId: timesheet.tsId,
            status: timesheet.status,
            date: `${convertToDateString(
              timesheet.fromDate,
              DB_DATE_FORMAT
            )} - ${convertToDateString(timesheet.toDate, DB_DATE_FORMAT)}`,
            name: user.firstName + ' ' + user.lastName,
            totalHrs: timesheet.total_hours,
            comments: timesheet.comments ? timesheet.comments : '',
            details: timesheet.days.map(day => {
              const dailyDetails = [];
              dailyDetails.push({
                date: convertToDateString(day.date, DB_DATE_FORMAT),
                hour: day.hour,
                task: day.task,
                projectId: day.projectId,
                status: day.is_billable ? 'Billable' : 'Non-Billable',
                note: day.note,
              });
              return dailyDetails;
            }),
            attachments: timesheet.attachments,
            timeSheetAudit:timesheet.timeSheetAudit||[],
            holiday: nonBillableObj.holiday,
            sick: nonBillableObj.sick,
            vacation: nonBillableObj.vacation,
          });
        });
      });
  }, [users]);

  useEffect(() => {
    setRows(rowData.timesheets);
  }, [users]);

  const handleDetailClose = () => setDetailOpen(false);
  const handleAuditClose = () => setAuditOpen(false);
  const handleEditClose = () => setEditOpen(false);
  const handleCommentClose = () => setCommentOpen(false);
  const handleAttachmentClose = () => setAttachmentOpen(false);
  const handlePopoverOpen = e => setAnchorEl(e.currentTarget);
  const handlePopoverClose = () => setAnchorEl(null);
  const handleAttachmentOpen = userObject => {
    setAttachmentOpen(true);
    setUserObj(userObject);
  };
  const handleDetailOpen = userObject => {
    setDetailOpen(true);
    setUserObj(userObject);
  };
  const handleAuditOpen = userObject => {
    setAuditOpen(true);
    setUserObj(userObject);
  };
  const handleEditOpen = obj => {
    setEditOpen(true);
    getEditDialogTimesheet(obj);
  };

  const handleCommentOpen = userObject => {
    setCommentOpen(true);
    setUserObj(userObject);
  };

  const handleApprove = async row => {
    let details = {
      userId: user.id,
      tsId: row.tsId,
      status: row.status === 'APPROVAL_PENDING' ? 'APPROVED' : 'APPROVAL_PENDING',
    };

    const resp = await dispatch(approveTimesheet(details));

    if (resp) {
      if (payPeriod.startDate && currentYear) {
        dispatch(
          fetchAllUsers({
            fromDate: `${payPeriod.startDate}`,
            toDate: `${payPeriod.endDate}`,
            role: user.role,
            projectCode: '4000',
          })
        );
      }
    }
  };

  const setTheSearchTerm = e => setSearchTerm(e.target.value);

  const sortArray = (arr, property) => () => {
    let array = [...arr];

    setOrderAscending(!orderAscending);

    orderAscending ? setAsc('asc') : setAsc('desc');
    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) {
              return -1;
            }
            if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
        })
      );
    }

    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const employeeDetailProps = {
    detailOpen,
    handleDetailClose,
    rows,
    employeeDetailColumns,
    userObj,
    projects: projects.allProjects,
  };

  const employeeAuditProps = {
    auditOpen,
    handleAuditClose,
    rows,
    empAuditColumns,
    userObj,
    projects: projects.allProjects,
    users:users
  };

  const editProps = {
    editOpen,
    handleEditClose,
    timesheet: timesheet,
    projects: projects.allProjects
  };

  const commentProps = {
    commentOpen,
    handleCommentClose,
    rows,
    commentColumns,
    userObj,
  };

  const attachmentContentProps = {
    attachmentOpen,
    handleAttachmentClose,
    generate,
    userObj,
    rows,
  };

  const popoverOpen = Boolean(anchorEl);

  const mainTableProps = {
    columns,
    rows,
    handleAttachmentOpen,
    popoverOpen,
    handlePopoverOpen,
    handlePopoverClose,
    anchorEl,
    handleDetailOpen,
    handleEditOpen,
    handleCommentOpen,
    handleApprove,
    sortArray,
    orderAscending,
    asc,
    searchTerm,
    user,
    handleAuditOpen
  };

  const goBack = () => {
    let _weekObj = {};
    _weekObj.startDate = moment(payPeriod.startDate, DB_DATE_FORMAT)
      .add(-7, 'day')
      .format(DB_DATE_FORMAT);
    _weekObj.endDate = moment(payPeriod.endDate, DB_DATE_FORMAT)
      .add(-7, 'day')
      .format(DB_DATE_FORMAT);
    setPayPeriod(_weekObj);
  };

  const goForward = () => {
    let _weekObj = {};
    _weekObj.startDate = moment(payPeriod.startDate, DB_DATE_FORMAT)
      .add(7, 'day')
      .format(DB_DATE_FORMAT);
    _weekObj.endDate = moment(payPeriod.endDate, DB_DATE_FORMAT)
      .add(7, 'day')
      .format(DB_DATE_FORMAT);
    setPayPeriod(_weekObj);
  };

  const formattedDateRange = () => {
    return `${moment(payPeriod.startDate, DB_DATE_FORMAT).format('MM/DD')} - ${moment(
      payPeriod.endDate,
      DB_DATE_FORMAT
    ).format('MM/DD')}`;
  };

  return (
    <>
      <h1>Approvals</h1>
      <Grid container justify='center' alignItems='center'>
        <Grid xs={12} sm={4} item className={gridElLeft}>
          <TextField
            type='search'
            label='Search'
            className={inputMobile}
            onChange={setTheSearchTerm}
            variant='outlined'
          />
        </Grid>
        <Grid xs={12} sm={4} item container justify='center'>
          <Button onClick={goBack}>
            <ArrowBackIosIcon className={arrowIcons} />
          </Button>
          <h2>{formattedDateRange()}</h2>
          <Button onClick={goForward}>
            <ArrowForwardIosIcon className={arrowIcons} />
          </Button>
        </Grid>
        {(user.role||'')=='clinetManager'?null:<Grid xs={12} sm={4} item className={gridElRight}>
          <ExcelExport {...mainTableProps} />
        </Grid>}
      </Grid>
      <MainTable {...mainTableProps} />
      <EmployeeDetailDialogue {...employeeDetailProps} />
      <EditDialogue {...editProps} />
      <CommentDialogue {...commentProps} />
      <EmployeeAudit {...employeeAuditProps}/>
      <AttachmentDialogue {...attachmentContentProps} />
    </>
  );
};

export default TimesheetApproval;
